<h2>Subscriptions</h2>
@if(isLoading) {
    <app-loading-page [message]="'Loading subscriptions'"></app-loading-page>
}
@else {
    <div class="grid-wrapper grid-lg">
        <kendo-grid
            [data]="subscriptions"
        >
            <kendo-grid-column field="label" title="Label"></kendo-grid-column>
            <kendo-grid-column field="status" title="Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="status-badge" [ngClass]="getStatusClass(dataItem.status)">
                        {{ dataItem.status }}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="planName" title="Plan"></kendo-grid-column>
            <kendo-grid-column field="users" title="Users"></kendo-grid-column>
            <kendo-grid-column field="instances" title="Instances"></kendo-grid-column>
            <kendo-grid-column field="started" title="Started">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.started | date:'mediumDate' }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="billingPeriod" title="Billing Period"></kendo-grid-column>
            <kendo-grid-column field="avgMonthlyTotal" title="Average Monthly Total">
                <ng-template kendoGridCellTemplate let-dataItem>
                    ${{ dataItem.avgMonthlyTotal }} / month
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="Actions" [width]="125">
            <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton class="btn-edit" (click)="onSelectSubscription(dataItem)">
                    Edit
                </button>
            </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>  
}